// src/App.tsx

import { Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ThemeProvider } from './app/providers/MuiThemeProvider';
import { ErrorBoundary } from './shared/components/feedback/ErrorBoundary';
import { Modals } from './app/Modals';
import { appRoutes } from './app/router/routes';

export default function App() {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <Routes>{appRoutes}</Routes>
        <Modals />
        {/* Single Sonner renderer so `toast.*` calls across the app are visible (A13). */}
        {/* Bottom placement keeps toasts clear of the header controls and the
            Return to Map button (Round 4 visual review). */}
        <Toaster position="bottom-right" richColors closeButton />
      </ErrorBoundary>
    </ThemeProvider>
  );
}
